module.exports = __webpack_public_path__ + "img/ic_refresh.997875bb.svg";